import { getObjectUtil, setUtil } from 'packages/src'
import { EXERCISE_LOG_SUMMARY_KEY } from '../../constants'

import { EXERCISE_LOG_SUMMARIES_PATH } from '../../../../exercise-log-summaries'
import {
  getIdReduxUtil,
  getValueReduxUtil
} from '../../../../redux'

function addToExerciseIdMap (state, instance) {
  const exerciseId = getValueReduxUtil(instance, EXERCISE_LOG_SUMMARY_KEY.EXERCISE_ID)
  return setUtil(
    state,
    `${EXERCISE_LOG_SUMMARIES_PATH.EXERCISE_ID_MAP}.${exerciseId}`,
    getIdReduxUtil(instance)
  )
}

function afterCreateExerciseLogSummaryHook (instance, state) {
  if (!getObjectUtil(state, EXERCISE_LOG_SUMMARIES_PATH.EXERCISE_ID_MAP)) {
    state = setUtil(state, EXERCISE_LOG_SUMMARIES_PATH.EXERCISE_ID_MAP, {})
  }
  return addToExerciseIdMap(state, instance)
}

export default afterCreateExerciseLogSummaryHook
